<template>
    <div>
        <div class="columns" style="border-bottom:1px solid;padding-top:5px;"
             :class="{active : is_current}"
        >
            <div class="column is-6" @click="nodeClicked">
                <span
                    :style="{'margin-left':`${depth*40}px`}"
                    style="display: inline-block"
                    :id="isCurrentCompany"
                >
                    <font-awesome-icon :icon="icon" :size="icon_size"></font-awesome-icon>
                    {{ node.name1 }} {{ node.name2 }}
                </span>
            </div>
            <div class="column is-1">{{node.customer_number}}</div>
            <div class="column is-1">{{node.zip}}</div>
            <div class="column is-2">{{node.city}}</div>
            <div class="column is-2">
                <router-link :to="{ name : 'my-company'}"
                    class="button"
                    v-show="is_current"
                >
                    <font-awesome-icon style="margin-right:5px" icon="edit"></font-awesome-icon>
                </router-link>
                <router-link :to="{ name : 'companies', params : {cid : node.id || cid}}"
                    class="button"
                    v-show="!is_current"
                >
                    <font-awesome-icon style="margin-right:5px" icon="tag"></font-awesome-icon>
                </router-link>
                <a class="button" @click="shopClicked(node.id)">
                    <font-awesome-icon  style="margin-right:5px" icon="shopping-cart"></font-awesome-icon>
                </a>
            </div>
        </div>
        <div v-if="node.expanded">
            <TreeBrowser
                v-for="child in node.children"
                :key="child.id"
                :node="child"
                :cid="cid"
                :depth="depth+1"
                @onClick="(node) => $emit('onClick',node)"
                @shopAs="(evt) => $emit('shopAs', evt)"
            />
        </div>
    </div>
</template>

<script>

export default {
    name:"TreeBrowser",
    props:{
        cid:Number,
        node:Object,
        depth:{
            type:Number,
            default:0
        }
    },
    data(){
        return{
            companyCurrent:localStorage.getItem("company"),
        }
    },
    methods:{
        editClicked(id){
            this.$router.push({ path: "/companies/" + id });
            this.$router.go();
        },
        shopClicked(id) {
            if (id == this.cid) { // shop for current company -> no route change allowed
                this.$emit ("shopAs", id)
            } else {
                localStorage.setItem ("triggerShopAs", id)
                this.$router.push({ path: "/companies/" + id });
            }
        },
        nodeClicked(){
            this.node.expanded = !this.node.expanded;
            if (this.node.has_children && this.node.children === undefined) {
                this.$store.dispatch (
                    "callSubSubCompanies",
                    { self: this, company: this.node.id })
            }
        }
    },
    computed:{
        is_current () {
            return this.node.id == this.cid
        },
        icon () {
            if (this.node.has_children) {
                if (this.node.expanded) return "caret-down"
                else                    return "caret-right"
            }
            return "bars"
        },
        icon_size () {
            if (this.node.has_children) return "1x"
            return "1x"
        },
        isCurrentCompany () {
            return this.is_current ? "current-company" : null
        }
    },
}
</script>

<style>
.node{
    text-align:left;
}

</style>
